import React from 'react';
import {Route} from "react-router-dom";
import LoadingMessage from '../../../components/loading/LoadingMessage';
import Media from "my-styles/media/media";
import AlertMessage, {ALERT_TYPES} from "../../../components/alertMassage/AlertMessage";
import DialogMessage from "components/dialogMessage/DialogMessage";
import Shared from "../shared/Shared";
import {categoryViewModel} from "../../../viewModels/Category.viewModel";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import messages from "res/messages/farsi";
import {v4 as uuidv4} from "uuid";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";

export default class Main extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            message: "",
            showAlert: false,
            showLoading: false,
            alertType: ALERT_TYPES.ERROR,
            login: {
                showLogin: false,
                goToLogin: undefined
            }
        }
    }

    componentDidMount() {
        categoryViewModel.requestCategorylist()
        authenticationViewModel.requestUser()
    }

    render() {

        function requestSetCustomerBehaviour(path, data) {
            let guid = localStorage.getItem("customerBehaviourGuid");
            if (!(guid && guid.length > 0)) {
                guid = uuidv4();
                localStorage.setItem("customerBehaviourGuid", guid);
            }

            let params = new FormData()
            params.append("guid", guid)
            params.append("action", path)
            if (data) {
                params.append("data", JSON.stringify(data).toString())
            }
            callApi(Urls.insertCustomerBehaviour, params)
        }

        const onNotificationClicked = (history, type, data) => {
            if (type === "2") {
                onNavigate(history, '/category?c=' + data + "&p=1")
            } else if (type === "3") {
                onNavigate(history, "/productDetail?v=" + data)
            } else if (type === "4") {
                onNavigate(history, '/category?searchText=' + data + "&p=1")
            } else if (type === "5") {
                window.open(data, "_blank")
            } else if (type === "6") {
                onNavigate(history, '/driverLocation?id=' + data.split(',')[0])
            } else if (type === "7") {
                // notifier = data
            } else if (type === "8") {
                onNavigate(history, '/rewards?t=' + data.split(',')[0] + "&d=" + data.split(',')[1])
            } else if (type === "9") {
                let categoryId = data
                let categoryType = ""
                let cond = ""

                if (data.contains(",")) {
                    let splits = data.split(",")
                    if (splits.size > 0) {
                        categoryId = splits[0]
                    }
                    if (splits.size > 1) {
                        categoryType = splits[1]
                    }
                    if (splits.size > 2) {
                        cond = splits[2]
                    }
                }

                if (cond === "") {
                    onNavigate(history, '/category?c=' + categoryId + "&p=1")
                } else {
                    if (cond.indexOf("category") !== -1) {
                        onNavigate(history, '/category?c=' + cond.split("=")[1] + "&type=" + categoryType + "&p=1")
                    } else if (cond.indexOf("manufacturer") !== -1) {
                        onNavigate(history, '/category?m=' + cond.split("=")[1] + "&type=" + categoryType + "&p=1")
                    }
                }
            } else if (type === "11") {
                onNavigate(history, '/')
            }
        }
        const onBannerClicked = (history, line) => {
            if (line) {
                if (line.type === "0") {
                    if (line.data.indexOf("category") !== -1) {
                        onNavigate(history, '/category?c=' + line.data.split("=")[1] + "&p=1")
                    } else if (line.data.indexOf("manufacturer") !== -1) {
                        onNavigate(history, '/category?m=' + line.data.split("=")[1] + "&p=1")
                    }
                } else if (line.type === "2") {
                    onNavigate(history, '/category?c=' + line.data.split('#')[0] + "&p=1")
                } else if (line.type === "3") {
                    onNavigate(history, "/productDetail?v=" + line.data)
                } else if (line.type === "4") {
                    onNavigate(history, '/category?searchText=' + line.data + "&p=1")
                } else if (line.type === "5") {
                    window.open(line.data, "_blank")
                } else if (line.type === "6") {
                    onNavigate(history, '/category?c=' + line.data.split('#')[0] + "&p=1")
                } else if (line.type === "7") {
                    let type = line.data.split('#')[1]
                    let cond = line.data.split('#')[2]
                    if (cond.indexOf("category") !== -1) {
                        onNavigate(history, '/category?type=' + type + "&c=" + cond.split("=")[1] + "&p=1")
                    } else if (cond.indexOf("manufacturer") !== -1) {
                        onNavigate(history, '/category?type=' + type + "&m=" + cond.split("=")[1] + "&p=1")
                    }
                }
            }
        }
        const onLoading = (status) => {
            this.setState({showLoading: status})
        }
        const onAlert = (message, type) => {
            this.setState({
                alertType: type ? type : ALERT_TYPES.ERROR,
                showAlert: true,
                message: message
            })
        }
            const onNavigate = (history, path, data) => {
            requestSetCustomerBehaviour(path, data)
            if (history && path) {
                if (window.location.href.endsWith(path)) {
                    window.location.reload()
                } else {
                    history.push(path, data)
                }
            }
                scrollToTop();
               // window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
        }
        const scrollToTop = () => {
            const scrollStep = -window.scrollY / (200 / 15);
            const scrollInterval = setInterval(() => {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                } else {
                    clearInterval(scrollInterval);
                }
            }, 1);
        };

        const onShowLogin = (login) => {
            this.setState({login: login})
        }

        return (<div>
            <Media/>
            <Route path='/' render={(props) => (
                <Shared
                    {...props}
                    onNotificationClicked={onNotificationClicked}
                    onBannerClicked={onBannerClicked}
                    onLoading={onLoading}
                    onNavigate={onNavigate}
                    onAlert={onAlert}
                    onShowLogin={onShowLogin}/>
            )}/>
            <LoadingMessage
                showStatus={this.state.showLoading}/>
            <AlertMessage
                alertType={this.state.alertType}
                message={this.state.message}
                showStatus={this.state.showAlert}
                onClose={() => {
                    this.setState({showAlert: false, message: ""})
                }}/>
            <DialogMessage
                showStatus={this.state.login.showLogin}
                title={messages.login}
                message={messages.sureLogin}
                submitTitle={messages.enter}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    this.setState({
                            login: {
                                showLogin: false,
                                goToLogin: undefined
                            }
                        }
                    )
                }}
                onSubmitClicked={() => {
                    if (this.state.login.goToLogin) {
                        this.state.login.goToLogin()
                    }
                    this.setState({
                            login: {
                                showLogin: false,
                                goToLogin: undefined
                            }
                        }
                    )
                }}
            />
        </div>)
    }

}